const ch = {
	key: 'ch',
	name: 'ChooseHealthy',
	getDesignTokens: mode => ({
		mode,
		primary: {
			main: '#0077C8',
			light: '#EAF1FF',
			dark: '#003259',
			...(mode === 'dark' && {
				main: '#0084DB',
				dark: '#488CB7',
				light: '#EAF1FF',
			}),
		},
		secondary: {
			main: '#006298',
			light: '#E8F2FF',
			dark: '#003352',
			...(mode === 'dark' && {
				main: '#0084C2',
				dark: '#3C86B4',
				light: '#E8F2FF',
			}),
		},
		tertiary: {
			main: '#0093B2',
			light: '#DCF5FF',
			dark: '#003542',
			...(mode === 'dark' && {
				main: '#0093B2',
				dark: '#1788A1',
				light: '#DCF5FF',
			}),
		},
	}),
};

export default ch;
